export class UserState {

    constructor() { }
    
    mode: string;
    userId : string;
    title : string;

}